import { benefits } from '../../data/landingPage';
import './BenefitsSection.css';

const icons = {
  lock: (
    <>
      <rect x="7" y="10" width="10" height="9" rx="2" />
      <path d="M9 10V8a3 3 0 0 1 6 0v2" />
    </>
  ),
  clock: (
    <>
      <circle cx="12" cy="12" r="8" />
      <path d="M12 7v5l3 2" />
    </>
  ),
  leaf: (
    <>
      <path d="M5 14c6-9 12-8 14-8-1 6-5 12-12 12-1.5 0-2.4-.6-3-1.4" />
      <path d="M8 15c2.5-1.2 5-3 7-6" />
    </>
  ),
  heart: (
    <path d="M12 19s-7-4.4-7-9.2A3.8 3.8 0 0 1 12 7a3.8 3.8 0 0 1 7 2.8C19 14.6 12 19 12 19Z" />
  ),
};

function BenefitIcon({ name }) {
  return (
    <svg viewBox="0 0 24 24" aria-hidden="true">
      {icons[name]}
    </svg>
  );
}

function BenefitsSection() {
  return (
    <section className="benefits" id="privacy" aria-label="RELI benefits">
      {benefits.map((benefit) => (
        <article key={benefit.title}>
          <span className={`benefit-icon ${benefit.accent}`}>
            <BenefitIcon name={benefit.icon} />
          </span>
          <div>
            <h3>{benefit.title}</h3>
            <p>{benefit.text}</p>
          </div>
        </article>
      ))}
    </section>
  );
}

export default BenefitsSection;
